import { Controller } from "@hotwired/stimulus"

// Auto-refresh del board del dashboard V2. Recarga el turbo-frame que lo envuelve
// (este controller vive en el <turbo-frame id="dashboard-board">) cada `interval`
// segundos. Usa Turbo (frame.reload): NO recarga la página entera y preserva los
// filtros porque se refresca la URL actual (que lleva los query params).
//
// Siempre activo, cada 5 min (dashboard/_board.slim).
// Stimulus 2.0: los value descriptors van como `name: ConstructorClass`.
export default class extends Controller {
  static values = {
    enabled: Boolean,
    interval: Number
  }

  initialize() {
    this._timer = null
  }

  connect() {
    if (!this.enabledValue) return

    // Turbo expone su API en window.Turbo. reload() vuelve a pedir el src del
    // frame; si no estuviera, caemos a re-asignar el src con la URL actual.
    const seconds = Number(this.intervalValue) || 900
    this._timer = setInterval(() => this.reload(), seconds * 1000)

    this.syncHeaderTime = this.syncHeaderTime.bind(this)
    this.element.addEventListener("turbo:frame-load", this.syncHeaderTime)
  }

  disconnect() {
    if (this._timer) clearInterval(this._timer)
    this.element.removeEventListener("turbo:frame-load", this.syncHeaderTime)
  }

  // A1: Sincroniza el sello del header móvil con el timestamp recién recargado
  // dentro del turbo-frame.
  syncHeaderTime() {
    const frameTime = this.element.querySelector(".tp-dash-update time")
    const headerTime = document.querySelector(".tp-dash-pagehead__update time")
    if (!frameTime || !headerTime) return

    if (frameTime.title) headerTime.title = frameTime.title
    if (frameTime.dateTime) headerTime.dateTime = frameTime.dateTime
    if (frameTime.dataset.v2RelativeTimeDatetimeValue) {
      headerTime.dataset.v2RelativeTimeDatetimeValue = frameTime.dataset.v2RelativeTimeDatetimeValue
    }
  }

  reload() {
    // Pestaña oculta: ahorra queries; al volver, el próximo tick actualiza.
    if (document.hidden) return

    // El src del frame se congela en la URL del primer reload: si el usuario
    // cambió vista/filtros después (history.replaceState, ver dashboard
    // controller), reload() re-pediría la URL vieja y el estado rebota al
    // default del server. Re-sincronizar siempre contra la URL actual.
    if (this.element.src === window.location.href) {
      this.element.reload()
    } else {
      this.element.src = window.location.href
    }
  }
}
